import { z } from 'zod';
import { AdminPageQuerySchema, adminPage } from './page';

/* Rooms (Circles) */
export const AdminRoomSchema = z.object({
  id: z.string(),
  name: z.string(),
  spotName: z.string(),
  members: z.number().int().nonnegative(),
  reports: z.number().int().nonnegative(),
  frozen: z.boolean(),
  archived: z.boolean(),
  approved: z.boolean(),
  createdAt: z.iso.datetime(),
});
export type AdminRoom = z.infer<typeof AdminRoomSchema>;

export const AdminRoomsQuerySchema = AdminPageQuerySchema.extend({
  filter: z.enum(['all', 'pending', 'active', 'reported', 'frozen', 'archived']).default('all'),
  q: z.string().max(120).optional(),
});
export type AdminRoomsQuery = z.infer<typeof AdminRoomsQuerySchema>;

export const AdminRoomsResponseSchema = adminPage(AdminRoomSchema);
export type AdminRoomsResponse = z.infer<typeof AdminRoomsResponseSchema>;

export const AdminRoomActionSchema = z.object({
  action: z.enum(['approve', 'freeze', 'unfreeze', 'archive', 'delete', 'set_rules']),
  rules: z.string().max(280).optional(),
  reason: z.string().min(3).max(500),
});
export type AdminRoomAction = z.infer<typeof AdminRoomActionSchema>;
